module.exports = __webpack_public_path__ + "fonts/Inter-ExtraBold.38bc51b.woff";